import pageTitleMessages from "./pageTitleMessages";
import feedbackModalsMessages from "./feedbackModalsMessages";
import hegMappingMessages from "./hegMappingMessages";
import toastMessages from "./toastMessages";
import tableHeaderMessages from "./tableHeaders";
import tBuilderValidationMessages from "./tBuilderValidationMessages";

const intlMessagesEn = {
  "common.app": "FLOWIO",
  "common.advanced": "Advanced",
  "common.show_all": "Show all",
  "common.delete": "Delete",
  "common.edit": "Edit",
  "common.password": "Password",
  "common.login": "Login",
  "common.yes": "Yes",
  "common.no": "No",
  "common.reload": "Reload",
  "common.send": "Send",
  "common.change": "Change",
  "common.insert": "Insert",
  "common.close": "Close",
  "common.back": "Back",
  "common.default": "Default",
  "common.detail": "Detail",
  "common.search": "Search",
  "common.save": "Save",
  "common.accept": "Confirm",
  "common.decline": "Decline",
  "common.favourite": "Favourite",
  "common.favourite_templates": "Favourite Templates",
  "common.invalid_value": "Invalid value",
  "common.select_all": "Select all",
  "common.unselect_all": "Unselect all",
  "common.fulltext.search": "Insert text",
  "common.advanced.search": "Advanced search",
  "common.icon": "Icon",
  "common.and_x_more": "Show {x} more",
  "common.show_less": "Show less",
  "common.chose": "Chose",
  "common.run": "Run",
  "common.reset": "Reset",
  "common.active": "Active",
  "common.update": "Update",
  "common.add": "Add",
  "common.filter": "Filter",
  "common.filters": "Filters",
  "common.more": "More",
  "common.less": "Less",
  "common.undo": "Undo",
  "common.order": "Order",
  "common.enter_text": "Enter text",
  "common.translation": "Translation",
  "common.import": "Import",
  "common.name": "Name",
  "common.error": "Error",
  "common.warning": "Warning",

  "confirmation.confirmAction": "Confirm action",

  "error_boundary.something_went_wrong": "Something went wrong",
  "error_boundary.rerender": "Refresh section",
  "error_boundary.go_to_homepage": "Go to homepage",

  "common.information": "Information",
  "common.tables": "Tables",
  "common.modules": "Modules",
  "common.templates": "Templates",
  "common.import_templates": "Import Templates",
  "common.diagnostic": "Diagnostics",
  "common.notifications": "Notfications",
  "common.functions": "Functions",
  "common.data_source": "Data source",
  "common.datasources": "Data sources",
  "common.user": "User",
  "common.users": "Users",
  "common.roles": "Roles",
  "common.personalization": "Personalization",
  "common.model": "Model",
  "common.new": "New",
  "common.copy": "Copy",
  "common.find": "Find",
  "common.loading": "Loading ...",
  "common.empty_list": "This list is empty",
  "common.common": "Common",
  "common.resolved": "Resolved",
  "common.unresolved": "Unresolved",
  "common.no_options": "No options",
  "common.save_for_all_users": "For all users:",
  "home.welcome": "Welcome to system ",
  "home.about":
    "FLOWIO allows you to process attendance, keep track of technical maintenance status, deal through central purchasing and keep costs under control",
  "home.favourite_templates": "Favourite Templates",
  "home.modules": "Modules",
  "home.modules.title": "Template description",

  "table.scheme.short": "Scheme",
  "table.schema.update": "Update schema",
  "table.schema.update.error": "Error occured during table schema update",
  "table.columns": "Columns",
  "table.columns.tooltip": "Table contain all columns",
  "table.columns.missing": "Missing column",
  "table.columns.missing.table": "Missing table",
  "table.columns.missing.tooltip": "Table is missing some columns",
  "table.add": "Add table",
  "table.row.edit": "Edit row detail",
  "table.row.inline_edit": "Edit row",
  "table.row.inline_copy": "Copy row",
  "table.row.copy_row": "Copy row detail",
  "table.name": "Table name",
  "table.scheme": "Table scheme",
  "table.reset_scheme": "Reset scheme",
  "table.data": "Table data",
  "table.data.value": "Table data: {value}",
  "table.row.insert": "New entry",
  "table.row.copy": "Copy entry",
  "table.row.add": "New entry",
  "table.row.add.detail": "New entry based on detail",
  "table.row.previous": "Previous entry",
  "table.row.next": "Next entry",
  "table.user_filter": " User filter",
  "table.detail": "Entry detail",
  "table.data_source_id": "Data source",
  "table.no_rows": "No data to display",
  "table.no_position_data.mobile_table":
    "To view this template in mobile view, the administrator must first set its mobile layout in presentation model",
  "table.no_position_data.detail":
    "To view this detail in mobile view, the administrator must first set its mobile layout in presentation model",
  "table.more_entries": "More entries ({entries})",
  "table.add_entry": "Add entry",
  "table.chose_item": "Chose item",
  "table.export_table": "Export table",
  "table.export_table.modal": "Export template {templateName}",
  "table.export_table.success":
    "Template was sucessfully transformed to desired form and saved to your local machine.",
  "table.export_table.table_name": "File name",
  "table.export_table.table_extension": "File type",
  "table.export_table.number_of_pages":
    "Number of pages to export (1-{numberOfPages})",
  "table.export_table.only_one_page": "Number of pages to export (1)",
  "table.export_table.export_all_pages": "Export all pages",
  "table.export_table.error.number_of_pages": "Wrong number of pages",
  "table.export_table.options": "Export options",
  "table.export_table.options.table": "Only table",
  "table.export_table.options.detail": "Only header",
  "table.export_table.options.table_and_detail": "Header and table",
  "table.export_table.columns_visibility": "Table columns visibility",
  "table.export_table.columns_visibility.settings":
    "Table columns visibility settings",
  "table.detail.save.error": "Error during saving detail",
  "table.detail.create.success": "Entry was successfully created",
  "table.overview.error": "Error during getting tables for overview select",
  "table.row.revalidation.error": "Error during table row revalidation",
  "table.paging.info": "Entries {from} to {to} from {totalRowCount}",

  "file_dropzone.label":
    "You can add files by clicking/pasting from clipboard/dragging them here",
  "file_dropzone.accepted_types": "Accepted file types: {types}",
  "file_dropzone.image_and_pdf": "Images and PDF",

  "templates.import": "Import template",
  "templates.Id": "Id",

  report_a_bug: "Report a bug",
  send_feedback: "Submit feedback",

  "bugs_overview.modal.title": "Overview of app bugs",
  "bugs_overview.modal.report": "Report",
  "bugs_overview.modal.remove": "Remove",
  "bugs_overview.modal.reported": "Bug was reported",

  "data_sources.add_source": "Add source",
  "data_sources.name": "Name",
  "data_sources.server": "Server",
  "data_sources.database": "Database",
  "data_sources.url": "URL",
  "data_sources.url_domain": "Domain URL",
  "data_sources.url_google": "Google URL",
  "data_sources.profile": "Profile",
  "data_sources.type": "Type",
  "data_sources.state": "State",
  "data_sources.login": "Login",
  "data_sources.password": "Password",
  "data_sources.maxConcurrentConnections": "Concurrent connections: ",
  "data_sources.mapping_type": "Mapping type",
  "data_sources.mapping_type.basic": "Basic",
  "data_sources.mapping_type.user": "User",
  "data_sources.mapping_type.servis_account": "Service account",
  "data_sources.mapping_type.servis_account_and_user":
    "User and Service account",
  "data_sources.mapping.domain": "Domain mapping",
  "data_sources.mapping.not_domain": "Notdomain mapping",
  "data_sources.mapping.google": "Google mapping",
  "data_sources.map_default_user": "Map",
  "data_sources.unmap_default_user": "Unmap",
  "data_sources.default_user_mapping": "Default mapping",
  "data_sources.allow_heg_sql_functions": "Heg sql functions",
  "data_sources.insert_disabled_info":
    "Default mapping will be available after the record has been inserted.",
  "data_sources.reset_column_schema": "Resetovat column schema",
  "data_sources.reset_column_schema.success": "Column schema was reseted",
  "data_sources.reset_column_schema.error":
    "Error during reseting column schema",
  "data_source.time_zones": "Time zone",
  "data_source.time_zones.fetch.error": "Error during time zones fetch",
  "data_sources.mapping.error.login_type":
    "Datasource need to have at least one mapping for user and mapping for service account",
  "data_sources.mapping.error.url": "Mapping type need to have URL assigned",
  "data_sources.login_type": "Login type",
  "data_sources.login_type.user": "Username and password",
  "data_sources.login_type.domain": "Domain",
  "data_sources.login_type.google": "Google",

  "modules.add_module": "Add module",
  "modules.name": "Name",
  "modules.visible": "Visible",
  "modules.description": "Description",
  "modules.picture": "Picture",
  "modules.add_picture": "Add picture",
  "modules.no_roles": "This module has no roles assigned to it",
  "modules.sort.modules": "Sort modules",
  "modules.sort.templates": "Sort templates for module {moduleName}",
  "modules.sort.modules.modal": "Modules sorting",
  "modules.sort.templates.modal": "Templates sorting for module {moduleName}",

  "roles.add_role": "Add role",
  "roles.add_roles": "Add roles",
  "roles.name": "Role name",
  "roles.type": "Role type",
  "roles.search": "Search roles...",
  "roles.guest": "Guest",
  "roles.editor": "Editor",

  "templates.add_template": "Add template",
  "templates.add_templates": "Add templates",
  "templates.create_template": "Create template",
  "templates.overview": "Overview",
  "templates.detail": "Detail",
  "templates.multi": "Multi-source",
  "templates.multi_detail": "Multisource detail",
  "templates.hwrAdaptionPlan": "Adaption Plan",
  "templates.hwrAnnualEval": "Annual Evaluation",
  "templates.hwrPersonalDevPlan": "Personal Development Plan",
  "templates.hwrPotentialEval": "Potential Evaluation",
  "templates.item": "Item based",
  "templates.name": "Name",
  "templates.table": "Table",
  "templates.device": "Device",
  "templates.visible": "Visible",
  "templates.displayAs": "Display as",
  "templates.module": "Module",
  "templates.type": "Type",
  "templates.notification": "Notification",
  "templates.calendar": "Calendar",
  "templates.system": "System",
  "templates.SSRS": "SSRS",
  "templates.search": "Search templates",
  "templates.description": "Description",
  "templates.order": "Order",
  "templates.info": "Template description",
  "templates.imported": "Imported",
  "templates.created": "From day",

  "templates.device.type.web": "Web",
  "templates.device.type.webAndMobile": "Web and mobile",
  "templates.device.type.mobile": "Mobile",
  "templates.device.modal.title":
    "Do you want to change the device type to all related templates?",
  "templates.device.modal.message":
    "Related templates are all detail and item templates that are on this template. If you don't want it, the device type will only be changed to the current template.",

  "templates.export.title": "Export template",
  "templates.export.label": "Exported tempalate",
  "templates.export.modal.title": "Export template {templateName}",
  "templates.export.modal.message":
    "Do you wish to export all the connected templates as well?",
  "templates.export.modal.post_message":
    "Connected templates are all the detail and item templates defined for the current template. If you dont wish to export them then only template {templateName} will be exported.",
  "templates.export.error":
    "Error occured during {templateName} template export. Try again please or let the administrator know.",

  "templates.import.refresh": "Refresh imports",
  "templates.import.modal.title": "Template import",
  "templates.import.modal.missing_file":
    "For template import file need to be uploaded in format JSON",
  "templates.import.modal.success": "Template was successfully imported.",
  "templates.import.modal.partial_success":
    "Template import was successfully uploaded to the server. To succsefully import the template you need to resolve problems on children template imports. There is {templatesCount} children templates waiting for import resolve.",
  "templates.import.modal.error": "Error occured during template import.",
  "templates.import.delete.success":
    "Import {importName} was successfully deleted.",
  "templates.import.delete.error":
    "Error occured during delete of import {importName}.",
  "templates.import.delete": "Delete import",
  "templates.import.empty": "You dont have any imports in progress",
  "templates.import.success": "Import of template/templates was successfull.",
  "templates.import.error":
    "Error occured during template/templates import. Reach out for administrator.",
  "templates.import.template": "Import template",
  "templates.import.templates": "Import templates",
  "templates.import.update": "Template import was updated succesfully",

  "templates.import.table.isValid": "Valid",
  "templates.import.table.isExist": "Exist",
  "templates.import.table.state": "State",
  "templates.import.table.state.original": "Original",
  "templates.import.table.state.updated": "Updated",
  "templates.import.table.state.imported": "Imported",
  "templates.import.table.state.notImported": "Not Imported",
  "templates.import.table.select": "Map table",
  "templates.import.table.select.modal": "Mapping table to table {name}",
  "templates.import.table.dataSource":
    "Tables from datasource: {dataSourceName}",

  "templates.import.function.select": "Map function",
  "templates.import.function.select.modal":
    "Mapping function to function {name}",
  "templates.import.function.dataSource":
    "Functions from datasource: {dataSourceName}",
  "templates.import.function.new_id": "New Id",
  "templates.import.function.empty":
    "Imported template does not contain any functions.",

  "templates.import.heg.classes_and_folders": "HeG classes and folders",

  "templates.import.overview.id": "Import Id",
  "templates.import.overview.count": "Templates to resolve",
  "templates.import.overview.export_date": "Export date",
  "templates.import.overview.export_user": "Exported by user",
  "templates.import.overview.import_date": "Import date",
  "templates.import.overview.import_user": "Imported by user",

  "templates.import.detail": "Forward to detail",
  "templates.import.detail.error":
    "Error occured during template import detail fetch.",
  "templates.import.detail.validate": "Validate import",
  "templates.import.detail.refresh": "Refresh import",

  "functions.title": "Functions",
  "functions.select_function": "Select function",
  "functions.add_function": "Add function",
  "functions.add_functions": "Add functions",
  "functions.edit_functions": "Edit functions",
  "functions.name": "Name",
  "functions.type": "Type",
  "functions.isCommon": "Is common",
  "functions.id": "Id",
  "functions.column": "Column",
  "functions.item_based": "Items",
  "functions.datasource": "Data source",
  "functions.parametersJSON": "Parameters",
  "functions.parent_column": "Column of parent",
  "functions.skipRecordsOnError": "Skip records with an error",
  "functions.params": "Parameters for function {name}",
  "functions.run": "Run function",
  "functions.database": "Database",
  "functions.function_id": "Function Id",
  "functions.search": "Search functions",
  "functions.function_without_template": "Function without a template ({name})",
  "functions.run_confirm_message": "Are you sure you want to run the function ",
  "functions.empty_list": "No functions can be run on selected items",
  "functions.workflow_comment": "Workflow action commentaty",
  "functions.workflow_comment.placeholder.mandatory":
    "Enter comment (required)",
  "functions.workflow_comment.placeholder.optional": "Enter comment (optional)",

  "functions.workflow_comment.type": "Comment on exec",
  "functions.workflow_comment.type.none": "None",
  "functions.workflow_comment.type.required": "Required",
  "functions.workflow_comment.type.optional": "Optional",

  "function.import_function": "Import function",
  "function.parameters.show": "Show parameters",
  "function.parameters.hide": "Hide parameters",
  "function.parameters.modal.title": "Detail of parameter {name}",
  "function.parameters.add": "Add parameters",
  "function.parameters.save": "Save parameters",
  "function.parameters.edit_filer": "Edit relative filter",

  "function.run.success": "Function finished successfully",
  "function.run.error": "Error during function execution",
  "function.run.warning": "Warning during function execution",

  "function.delete.message":
    "Function you are up to delete is contained in the following templates. Are you certain you want to delete this function?",
  "function.delete.message.p.m":
    "Function will be deleted as well from templates listed above.",
  "function.delete.templates.active": "Active templates",
  "function.delete.templates.deleted": "Deleted templates",
  "function.delete.templates.overview": "Function within templates overview",

  "administration.title": "Administration",
  "administration.info":
    "Only users with the Administrator role can access the administration",
  "administration.tables":
    "<strong>Tables </strong> are used to select tables from the data database above which templates can be created.",
  "administration.modules":
    "<strong>Modules </strong> are displayed on the main page and combine templates below. They must have roles assigned - users in that role will have access to the module.",
  "administration.templates":
    "<strong>Templates </strong> define the model by which data from the selected table will be displayed. You can choose between overview and detail templates. The overview template may include another detail template below it. Must have roles assigned - users will have access to the template and be able to edit / view data by role type.",
  "administration.data_source":
    "<strong>Data sources </strong> are used to define each database connection. New entries are added by the administrator.",
  "administration.users":
    "<strong>Users </strong> are individual users of the app. They must be assigned to roles. New users are added by the administrator.",
  "administration.roles":
    "<strong>Roles </strong> group users together and give them the right to view modules and templates. They are divided into 2 types - Host and Editor. The guest only has the right to view the data and the Editor can edit it (delete, add, edit).",
  "administration.personalization":
    "<strong>Personalization </strong> allows the user to change the appearance of the app. This means the background, button and title colors, images, titles, and more.",
  "administration.image": "Icon",
  "administration.template_versions": "Template versions",
  "administration.template_versions.current_version": "Version",
  "administration.template_versions.apply": "Apply template version",
  "administration.nav.template_builder": "Model for template {templateId}",
  "administration.nav.settings": "Template settings",
  "administration.nav.data_model": "Data model",
  "administration.nav.presentation_model": "Prezentation model",
  "administration.nav.overview": "Show overview",

  "localization.label": "Language",
  "localization.czech": "Čeština",
  "localization.english": "English",

  "localization.cs": "Czech",
  "localization.en": "English",

  "settings.personal_settings": "Personal settings",
  "settings.personal.name": "Name",
  "settings.personal.surname": "Surname",
  "settings.personal.email": "Mail",
  "settings.personal.birth": "Date of birth",
  "settings.dashboard_settings": "Dashboard settings",
  "settings.app_settings": "App settings",
  "settings.template_entries": "Default number of entries on templates",

  "warning.error": "Error",
  "warning.required": "This field is required",
  "warning.user_name_already_existing": "User name already existing",
  "warning.login_name_already_existing": "Login name already existing",
  "warning.short_password": "Password must contains at least 6 characters",
  "warning.passwords_dont_match": "Passwords dont match",
  "warning.not_an_email": "Not valid email",
  "warning.no_filled_email": "User has no email filled",

  "registration.registration": "Register",
  "registration.new_user": "New user",
  "registration.user_name": "Name and surname: ",
  "registration.login_name": "Login name: ",
  "registration.password": "Password: ",
  "registration.password_again": "Password again:",
  "registration.user_name.no_dots": "User name",
  "registration.login_name.no_dots": "Login name",
  "registration.old_password": "Old password:",
  "registration.new_password": "New password:",
  "registration.new_password_again": "New password again:",
  "registration.email_address": "Email:",
  "registration.deactivated": "Deactivated",
  "registration.deactivate": "Deaktivate",
  "registration.deactivation_date": "Date of deactivation",
  "registration.activate": "Aktivate",
  "registration.reset_password": "Reset passwords",
  "registration.success": "User {user_name} was successfully registered.",
  "registration.error.existing_login":
    "User with provided login already exists!",
  "registration.error.existing_email":
    "User with provided email already exists!",

  "template_builder.info.title": "Template model",
  "template_builder.info.detail": "Template model detail",
  "template_builder.info.move": "Move to template model",
  "template_builder.info.description":
    "The <strong> Template Model </strong> defines the model by which data from the selected table will be displayed.",
  "template_builder.info.data_model":
    "The <strong> Data Model </strong> is used to define the columns from which the data in the resulting form is displayed.",
  "template_builder.info.table_data":
    "the <strong> Spreadsheet Data </strong> button can be used to view source / model table source data",
  "template_builder.info.row":
    "A <strong> row </strong> represents one column from the database",
  "template_builder.info.box_row":
    "<strong> Box in row </strong> represents the properties of this column. This column can be linked to other columns using data shared between the two columns. The JOIN is determined by the <i> Column Display </i> from the source column and the <i> Column Value </i> of the target column.",
  "template_builder.info.left_side_btn":
    "<strong> The left side button </strong> adds a new connection",
  "template_builder.info.middle_btn":
    "<strong> The × between boxes </strong> button breaks the connection",
  "template_builder.info.alias":
    "<strong> Alias ​​</strong> defines the column name in the report / detail",
  "template_builder.info.table":
    "A <strong> Spreadsheet </strong> determines which spreadsheet data comes from",
  "template_builder.info.column.1":
    "A <strong> Value column </strong> determines which column the data is coming from",
  "template_builder.info.column.2":
    "The <strong> Value column </strong> determines which column will be displayed in the report / detail",
  "template_builder.info.type": "Type",
  "template_builder.info.value":
    "<strong> Value </strong> is not an unmodified value from the database",
  "template_builder.info.selection":
    "<strong> Selection </strong> Select from several values. The <i> value </i> must match the data in the database. <i> Text </i> determines how the value is displayed to the user",
  "template_builder.info.join": "<strong> JOIN </strong> join another column",
  "template_builder.info.join.type":
    "The <strong> JOIN type </strong> defines how table rows that do not meet the join condition are handled. <i> INNER </i> won't include records from either table. <i> LEFT </i> will include entries from the target join table. <i> RIGHT </i> will include entries from the junction source table.",
  "template_builder.info.condition":
    "<strong> + Condition </strong> adds a condition that the data in the column must meet.",
  "template_builder.info.condition.value":
    "<strong> Value </strong> is either equal to, greater than or less than the exact value in the last field",
  "template_builder.info.condition.similar":
    "<strong> Similar to </strong> eg _A% shows all records where the second letter is uppercase A (case sensitive will include records where the second letter is lowercase a)",
  "template_builder.info.new_row":
    "<strong> New row </strong> Adds a new row to the data model",
  "template_builder.info.form_model":
    "The <strong> Form Model </strong> defines the behavior of the form that the user gets when they click New Entry / Edit / Detail.",
  "template_builder.info.view":
    "<strong> Preview </strong> shows the resulting data presentation when the template is displayed.",
  "template_builder.info.table_detail":
    "<strong> Table / Detail </strong> displays the resulting table / detail",
  "template_builder.info.sql":
    "<strong> SQL </strong> displays the SQL query generated by the data template",
  "template_builder.data_model": "Data model",
  "template_builder.data_model.filter": "Filter table",
  "template_builder.data_model.type.items": "Items",
  "template_builder.data_model.type.sql": "SQL",
  "template_builder.data_model.type.info":
    "Chose one of the options for data model setting",
  "template_builder.data_model.sql.alert":
    "To the changes to take effect you firstly need to apply SQL query",
  "template_builder.data_model.sql.upload": "Apply SQL query",
  "template_builder.data_model.sql.success":
    "The SQL query was executed successfully. Don't forget to save the template.",
  "template_builder.data_model.error":
    "Error occured while applying the SQL query",
  "template_builder.presentation_model": "Presentation model",
  "template_builder.presentation_model.no_mobile_layout":
    "Mobile layout is not defined, and it is thus impossible to display the template on mobile",
  "template_builder.presentation_model.display_conditions":
    "Display conditions",
  "template_builder.presentation_model.editable_conditions":
    "Editability conditions",
  "template_builder.presentation_model.prefill_rules": "Prefill rules",
  "template_builder.presentation_model.prefill_rules.condition": "Condition",
  "template_builder.presentation_model.prefill_rules.value": "Prefilled value",
  "template_builder.presentation_model.title.alert":
    "It's not possible to pick column type Title because this type is already assigned to column {name}.",

  "template_builder.model": "Model",
  "template_builder.table_data": "Table data",
  "template_builder.is_template_heg": "Is template related to HeG?: ",
  "template_builder.provider": "Binder: ",
  "template_builder.add_row": "Add row",
  "template_builder.items": "Items",
  "template_builder.information": "Information",
  "template_builder.chose_template": "Select Item Template:",
  "template_builder.chose_join_column": "Select an item link column:",
  "template_builder.alias_column_detail": "Link column (detail)",
  "template_builder.alias_column_item": "Link column (item)",
  "template_builder.settings.template_item_order": "Template order",
  "template_builder.settings.order_placeholder": "Order",
  "template_builder.settings.filters": "Visibility condition",
  "template_builder.settings.filter_modal":
    "Visibility conditions for item template on detail ",

  "template_builder.model.detail_templates": "Detail templates",
  "template_builder.model.chosen_templates": "Chosen templates",
  "template_builder.model.empty_list": "Empty list",

  "template.edit.row": "Date should not be before minimal date",
  "calender.clear": "Clear",
  "calender.cancel": "Cancel",

  "template_builder.functions": "Functions",
  "template_builder.functions.tooltip": "Tooltip",
  "template_builder.functions.confirm_before_running": "Confirm before running",
  "template_builder.functions.resolve_notification":
    "Resolve task notification",
  "template_builder.functions.chose_functions": "Chose functions",
  "template_builder.functions.item_title": "Template",
  "template_builder.functions.source_name": "this template",
  "template_builder.functions.heg_number_class": "HeG class number: ",
  "template_builder.functions.edit_buttons": "Adjust function keys",
  "template_builder.functions.icon": "PC icon",
  "template_builder.functions.icon_mobile": "Mobile icon",
  "template_builder.functions.color": "PC color",
  "template_builder.functions.color_mobile": "Mobile color",
  "template_builder.functions.alias": "PC alias",
  "template_builder.functions.alias_mobile": "Mobile alias",
  "template_builder.functions.override_left_gesture": "Left gesture",
  "template_builder.functions.override_right_gesture": "Right gesture",
  "template_builder.functions.display_conditions": "Display conditions",
  "template_builder.functions.common_function": "Common function",
  "template_builder.settings": "Settings",
  "template_builder.settings.allow_edit": "Enable editing: ",
  "template_builder.settings.allow_copy": "Enable copying",
  "template_builder.settings.allow_copy_in_row": "Enable copying in row: ",
  "template_builder.settings.allow_edit_in_row": "Enable editing in row: ",
  "template_builder.settings.allow_delete": "Enable deleting: ",
  "template_builder.settings.allow_create": "Enable creating: ",
  "template_builder.settings.allow_create_in_row": "Enable creating in row:",
  "template_builder.settings.allow_table_export": "Enable table export: ",
  "template_builder.settings.allow_create.alert.detail":
    "In order to create new entries based on a template detail, it is necessary to first link a detail template",
  "template_builder.settings.allow_report_export": "Allow report export",
  "template_builder.settings.allow_create.alert.editInRow":
    "In order to create new entries in-line, it is necessary to also allow in row editing",
  "template_builder.settings.chose_action": "Chose action",
  "template_builder.settings.model_form": "Form model",
  "template_builder.settings.detail_template": "Detail template",
  "template_builder.settings.overview_template": "Overview template",
  "template_builder.settings.item_template": "Item template",
  "template_builder.settings.order": "Order: ",
  "template_builder.settings.mandatory_items": "Mandatory items: ",
  "template_builder.settings.aggregation_groups": "Aggregation groups",
  "template_builder.settings.heg_classes": "HeG classes",
  "template_builder.settings.heg_folders": "HeG folders",
  "template_builder.settings.create_detail_template": "Create new template",
  "template_builder.settings.allow_unsubscribe":
    "Allow notification unsubscribe",
  "template_builder.settings.allow_unsubscribe_tooltip":
    "By enabling this option user can unsubscribe notifications of this template. Administrator can unsubscribe all the time.",
  "template_builder.settings.link_to_report": "Link to report",
  "template_builder.settings.report_params": "Report parameters",
  "template_builder.settings.notification_is_task": "Notification is task",
  "template_builder.settings.kpi.displayAsKpi": "Display as KPI",
  "template_builder.settings.kpi.criticalThreshold": "Critical threshold",
  "template_builder.settings.kpi.importantThreshold": "Important threshold",
  "template_builder.view": "View SQL query",
  "template_builder.view.form": "Form",
  "template_builder.view.table": "Table",
  "template_builder.view.sql": "SQL",
  "template_builder.view_model": "View model",
  "template_builder.footer.save": "Save model",
  "template_builder.footer.help": "Help",
  "template_builder.add_group": "Add group",
  "template_builder.agr_groups.name": "Name: ",
  "template_builder.agr_groups.sum": "Sum",
  "template_builder.agr_groups.string_chain": "Connection of strings",
  "template_builder.agr_groups.items": "Items: ",
  "template_builder.agr_groups.types": "Type: ",
  "template_builder.agr_groups.from_model": "from model",
  "template_builder.agr_groups.static_value": "static value",
  "template_builder.agr_groups.item": "Item of data model: ",
  "template_builder.agr_groups.value": "Value: ",
  "template_builder.agr_groups.add_item": "Add item:",
  "template_builder.agr_groups.no_item": "No items",

  "template_builder.agr_group_editor.header": "Output styling settings",
  "template_builder.agr_group_editor.header_label": "Display as:",
  "template_builder.agr_group_editor.as_title": "Title",
  "template_builder.agr_group_editor.as_color": "Color",
  "template_builder.agr_group_editor.as_icon": "Icon",
  "template_builder.agr_group_editor.as_default": "Text",
  "template_builder.agr_group_editor.color_options": "Color options",
  "template_builder.agr_group_editor.icon_options": "Icon options",
  "template_builder.agr_group_editor.range_type.absolute": "Absolute",
  "template_builder.agr_group_editor.range_type.relative": "Relative",
  "template_builder.agr_group_editor.today": "Today",

  "value_definer.static_value": "static value",
  "value_definer.data_template_item": "Item of data model",

  "template_builder.set_function_icon": "Set icon appearance",
  "template_builder.set_color_appearance": "Set color of function",
  "template_builder.save_success": "successfully saved",
  "template_builder.box.default_item":
    "Default item (reprezentation of table ID)",
  "template_builder.box.alias": "Alias: ",
  "template_builder.box.editable": "Editable: ",
  "template_builder.box.existing_join": "Existing JOIN:",
  "template_builder.box.sorting_order": "Sorting order:",
  "template_builder.box.sorting_type": "Sorting type: ",
  "template_builder.box.sorting_asc": "Ascending",
  "template_builder.box.sorting_desc": "Descending",
  "template_builder.box.table": "Table: ",
  "template_builder.box.column_value": "Column with value: ",
  "template_builder.box.column_active": "Active column: ",
  "template_builder.box.type": "Type: ",
  "template_builder.box.dynRel": "Dynamic relation: ",
  "template_builder.box.staticRel": "Static relation: ",
  "template_builder.box.template_id": "Template Id:",
  "template_builder.box.relation_id": "Relation Id",
  "template_builder.box.is_extension_editable": "Edit table:",
  "template_builder.box.is_extension_editable.info":
    "Check this field in case you want to allow user to edit connected tables as well.",
  "template_builder.box.disable_trigger_events": "Disable trigger events",
  "template_builder.box.select.value": "Value",
  "template_builder.box.select.static": "Static choice",
  "template_builder.box.select.dynamic": "Dynamic choice",
  "template_builder.box.select.overviewSelect": "Overview select",
  "template_builder.box.select.join": "JOIN",
  "template_builder.box.select.hidden": "Hidden",
  "template_builder.box.select.heg_file": "HeG Files",
  "template_builder.box.select.file": "Files",
  "template_builder.box.select.agr_group": "Agr. Groups",
  "template_builder.box.select.aggregation": "Aggregation group",
  "template_builder.box.select.category": "Category",
  "template_builder.box.select.rel_number": "Relation number: ",
  "template_builder.box.select.file_folder_number": "Folder number: ",
  "template_builder.box.select.subject_number_column":
    "Subject number column: ",
  "template_builder.box.select.values": "Selection values: ",
  "template_builder.box.select.values.label": "Label",
  "template_builder.box.select.values.value": "Value",
  "template_builder.box.select.values.range": "Range",
  "template_builder.box.select.values.range_type": "Date range type",
  "template_builder.box.select.join_type": "JOIN types",
  "template_builder.box.select.inner_join": "INNER JOIN",
  "template_builder.box.select.left_join": "LEFT JOIN",
  "template_builder.box.select.right_join": "RIGHT JOIN",
  "template_builder.box.select.condition": "Condition",
  "template_builder.box.select.column": "column: {display_column}",
  "template_builder.box.select.like": "Similar as",
  "template_builder.box.select.dependency": "dependant on letter size: ",
  "template_builder.box.select.label": "Notification label",
  "template_builder.box.select.link": "Template link",
  "template_builder.box.select.link.label": "Detail template",
  "template_builder.box.select.dateFrom": "Date from",
  "template_builder.box.select.dateTo": "Date to",
  "template_builder.box.select.title": "Title",
  "template_builder.box.select.icon": "Icon",
  "template_builder.box.select.color": "Color",
  "template_builder.box.select.relation_type": "Relation type",
  "template_builder.box.select.none_relation": "None",
  "template_builder.box.select.static_relation": "Static",
  "template_builder.box.select.dynamic_relation": "Dynamic",
  "template_builder.box.select.priority_settings": "Priority settings",
  "template_builder.box.select.priority": "Priority",
  "template_builder.box.select.normal": "Normal",
  "template_builder.box.select.highest_priority": "Highest",
  "template_builder.box.select.high_priority": "High",
  "template_builder.box.select.medium_priority": "Middle",
  "template_builder.box.select.low_priority": "Low",
  "template_builder.box.select.lowest_priority": "Lowest",

  "template_builder.box.select.file.table": "Table",
  "template_builder.box.select.file.content_column_name": "Column for data",
  "template_builder.box.select.file.name_column_name": "Column for file name",
  "template_builder.box.select.file.key_column_name": "Column for unique key",

  "template_builder.box.select.file.content_format_type": "Data format",
  "template_builder.box.select.file.content_format_type.byte_array":
    "Byte array",
  "template_builder.box.select.file.content_format_type.base64_string":
    "Text string",

  "template_builder.box.select.file.identifier_type": "Key type",
  "template_builder.box.select.file.identifier_type.recordId": "Record id",
  "template_builder.box.select.file.identifier_type.aggGroup":
    "Aggregation groups",

  "template_builder.box.attribute_format": "Attribute format",
  "template_builder.box.value_format": "Value format",
  "template_builder.box.column_format": "Column format",

  "template_builder.box.format.attribute_text_align": "Allign attribute:",
  "template_builder.box.format.value_text_align": "Allign value:",
  "template_builder.box.format.text_align.center": "Center",
  "template_builder.box.format.text_align.left": "Left",
  "template_builder.box.format.text_align.right": "Right",

  "template_builder.box.format.display_variant": "Display variant:",
  "template_builder.box.format.display_variant.icon": "Icon",
  "template_builder.box.format.display_variant.text": "Text",
  "template_builder.box.format.display_variant.text_icon": "Icon + text",
  "template_builder.box.format.display_variant.none": "None",

  "template_builder.box.format.mobile_variant": "Mobile display variant:",
  "template_builder.box.format.mobile_variant.use_normal": "Same as on web",

  "template_builder.box.format.show_on_mobile": "Show on mobile:",
  "template_builder.box.format.show_on_mobile.show": "Show",
  "template_builder.box.format.show_on_mobile.hide": "Hide",

  "template_builder.box.format.number": "Number format",
  "template_builder.box.format.number.round_to": "Round to:",
  "template_builder.box.format.number.rounding_direction":
    "Rounding direction:",
  "template_builder.box.format.number.rounding_direction.up": "Up",
  "template_builder.box.format.number.rounding_direction.down": "Down",
  "template_builder.box.format.number.unit": "Unit:",
  "template_builder.box.format.number.thousandsSeparator":
    "Thousands separator:",
  "template_builder.box.format.number.divisor": "Divisor:",
  "template_builder.box.format.number.view": "Number look:",
  "template_builder.box.format.number.min_value": "Minimum value:",
  "template_builder.box.format.number.max_value": "Maximum value:",
  "template_builder.box.format.number.showNumberAsTime": "Show number as time:",

  "template_builder.box.format.date.date_formatting": "Date format",
  "template_builder.box.format.date.date_format": "Date format",
  "template_builder.box.format.date.date_format.date": "Date",
  "template_builder.box.format.date.date_format.time": "Time",
  "template_builder.box.format.date.date_format.datetime": "Date and time",
  "template_builder.box.format.date.date_format.month": "Month",
  "template_builder.box.format.date.date_format.year": "Year",
  "template_builder.box.format.date.min_value": "Minimum value:",
  "template_builder.box.format.date.max_value": "Maximum value:",

  "template_builder.box.format.date.text_formatting": "Text formatting",
  "template_builder.box.format.date.text_format.as_textarea":
    "Display as textarea",

  "template_builder.box.format.date.text_format.as_phone_mail":
    "Display as phone number/email",
  "template_builder.box.format.required": "Required",

  "template_builder.box.format.file.file_settings": "File settings",
  "template_builder.box.format.file.file_size": "File size (kB)",
  "template_builder.box.format.file.allowed_file_types": "Allowed file types",
  "template_builder.box.item_settings": "Settings for item {item_name}",

  "template_builder.column_position_editor.add_item": "Add a new item",
  "template_builder.column_position_editor.type": "Type",
  "template_builder.column_position_editor.label": "Column label",
  "template_builder.column_position_editor.value": "Value",
  "template_builder.column_position_editor.cancel": "Cancel",
  "template_builder.column_position_editor.add": "Add",
  "template_builder.column_position_editor.number_of_columns":
    "Number of columns ",
  "template_builder.column_position_editor.number_of_rows": "Number of rows",
  "template_builder.column_position_editor.rowspan": "Rowspan",
  "template_builder.column_position_editor.colspan": "Colspan",
  "template_builder.column_position_editor.edit_mode.turn_on":
    "Turn on edit mode",
  "template_builder.column_position_editor.edit_mode.turn_off":
    "Turn off edit mode",
  "template_builder.column_position_editor.same_for_mobile":
    "Same view for mobile",
  "template_builder.column_position_editor.number_range":
    "Number must be in range from 1 to {range}",

  "template_builder.column_position_editor.entity_position": "Entity position",
  "template_builder.column_position_editor.values": "Values",
  "template_builder.column_position_editor.labels": "Labels",
  "template_builder.column_position_editor.delimiters": "Delimiters",
  "template_builder.column_position_editor.delimiter.position": "Position",
  "template_builder.column_position_editor.delimiter.pattern": "Pattern",
  "template_builder.column_position_editor.delimiter.empty": "Empty",
  "template_builder.column_position_editor.delimiter.line": "Line",
  "template_builder.column_position_editor.delimiter.dotted_line":
    "Dotted line",
  "template_builder.column_position_editor.delimiter.horizontal": "Horizontal",
  "template_builder.column_position_editor.delimiter.vertical": "Vertical",
  "template_builder.column_position_editor.delimiter.line_horizontal":
    "Horizontal line",
  "template_builder.column_position_editor.delimiter.line_vertical":
    "Vertical line",
  "template_builder.column_position_editor.delimiter.dotted_line_horizontal":
    "Dotted horizontal line",
  "template_builder.column_position_editor.delimiter.dotted_line_vertical":
    "Dotted vertical line",
  "template_builder.column_position_editor.delimiter.type": "Delimiter type",

  "template_builder.errorMessage.duplicateSelectValues":
    "Some of presentation template items have duplicate select values",
  "template_builder.errorMessage.duplicateSelectNames":
    "Some of presentation template items have duplicate select texts",
  "template_builder.errorMessage.missingHegClassId": "Select a HeG class.",
  "template_builder.errorMessage.missingHegFolderId": "Select a HeG folder.",
  "template_builder.errorMessage.missingItemColumnAlias":
    "Select an item link column.",
  "template_builder.errorMessage.missing_detail_mobile_layout":
    "Detail templates require a mobile row layout",
  "template_builder.errorMessage.emptySortOrder":
    "One of the items with sort type is missing sort order",
  "template_builder.errorMessage.missingHegFileRelation":
    "One of the Heg File items is missing a linking template",
  "template_builder.errorMessage.missingColumn":
    "One of the items is missing join column",
  "template_builder.errorMessage.missingDisplayColumn":
    "One of the items is missing display column",
  "template_builder.sql_query.copy": "Copy query to clipboard",
  "template_builder.sql_query.stale_data":
    "Unsaved changes to the template model cannot be reflected in SQL query preview. " +
    "The following query corresponds to the last saved version. " +
    "You must save your unsaved changes for the SQL query to reflect them.",
  "template_builder.sql_query.save_and_reload": "Save model and update query",

  "template_builder.data_reload.message": "Data changed",
  "template_builder.data_reload.button": "Refresh data",
  "template_builder.validation.missing_detail":
    "You need to set detail when editing is allowed.",
  "template_builder.not_mapped":
    "Mapping is missing! Check templates default mapping at datasource.",

  "users.title": "Users",
  "users.add_user": "Add user",
  "users.show_mapping": "Show mapping",
  "users.user_mapping.title": "Data sources mapping for {user_name}",
  "users.user_mapping.map_user": "Map user",
  "users.user_mapping.remove_user": "Remove user mapping",
  "users.user_mapping.map_user.title": "Data source {data_source}",
  "users.user_mapping.map_user.input": "HeG user name:",
  "users.user_mapping.error": "Mapping for user {newHegUser} failed:",
  "users.send_credentials": "Send credentials",
  "users.send_credentials.user.success":
    "User credentials were sent to user {userName}.",
  "users.send_credentials.users.success":
    "User credentials were sent to selected users.",
  "users.send_credentials.error":
    "Error occured during user credentials sending. Please let know the administrator.",

  "personalization.title": "Personalization of application",
  "personalization.colors": "Colors",
  "personalization.version": "Version: {version}",
  "personalization.chose_color": "Chose color",
  "personalization.colors.changeBg": "<strong>Change background color</strong>",
  "personalization.colors.changeBg.modal": "Chose background color",
  "personalization.colors.primary":
    "<strong>Change primary color</strong> (color of modules, basic buttons or menu color)",
  "personalization.colors.primary.modal": "Chose primary color",
  "personalization.colors.secondary":
    "<strong>Change secondary color</strong> (other details and headings)",
  "personalization.colors.secondary.modal": "Chose secondary color",
  "personalization.colors.restore_defaults": "Restore default colors",

  "personalization.main_page": "Main page",
  "personalization.main_page.title": "Title",
  "personalization.main_page.description": "Description",
  "personalization.main_page.templates_count":
    "Visible templates count on module",
  "personalization.main_page.visibility.title": "Visible title",
  "personalization.main_page.visibility.description": "Visible description",
  "personalization.main_page.visibility.google_play": "Visible Google Play",
  "personalization.main_page.visibility.apple_store": "Visible Apple Store",
  "personalization.google_play.attribution":
    "Google Play and the Google Play logo are trademarks of Google LLC.",
  "personalization.login.title": "Settings of allowed login options",
  "personalization.login.standard": "Login and password",
  "personalization.login.google": "Google login",
  "personalization.login.microsoft": "Microsoft login",
  "personalization.login.directory": "Active directory",
  "personalization.data_format.title": "Customize application data",
  "personalization.data_format.number_of_decimals": "Number of decimal places",
  "personalization.user_section": "Uživatelská část",
  "personalization.user_secttion.bug_report": "Umožnit nahlášení chyby",
  "personalization.user_secttion.send_feedback":
    "Umožnit odeslat zpětnou vazbu",
  "personalization.user_secttion.auditlog": "Auditlog",
  "personalization.user_secttion.days_to_keep_log":
    "Number of days to keep log",

  "personalization.error.no_selected_login":
    "At least one option of login has to be selected",

  "segments.decline_icon": "Decline icon",
  "segments.find_icon": "Find icon by name",
  "segments.chose_icon": "Chose icon",
  "segments.module.colors.chose": "Chose",
  "segments.module.colors.decline": "Decline color",
  "segments.admin_only": "This section is allowed only for administrators.",
  "segments.password.alert": "Password for mapped user is wrong",
  "segments.password.heg_pswd": "Type password for HeG: ",
  "segments.password.set": "Set",
  "segments.password.change_mapping": "Change mapping",
  "segments.data_source.title": "Data source",
  "segments.data_source.placeholder": "Chose source",
  "segments.tables.placeholder.loading": "Loading tables ...",
  "segments.tables.placeholder.select_data_source_first":
    "Select a data source first",
  "segments.tables.placeholder.chose": "Chose table",
  "segments.tables.add": "Add",
  "segments.tables.chose_value": "Chose value",
  "segments.delete_confirm": "Do you really want to delete this item?",
  "segments.file_list.alert":
    "View map is not currently supported on FLOWIO for Android. You can view the following link in a row.",
  "segments.file_list.multiple_files": "Files ({count})",
  "segments.file_input.error": "Error during saving file (files)",
  "segments.file_list.no_files": "No files",
  "segments.file_input.files_upload.error":
    "We are sorry, but we couldn't upload next files: {fileNames}",
  "segments.file_input.download.error": "Error during file download",
  "segments.file_input.files_delete.error":
    "We are sorry, but we couldn't delete next files: {fileNames}",

  "segments.file_input.tooltip.upload_file": "Upload new attachment",
  "segments.file_input.tooltip.disable_reason":
    "Upload file is allowed only on existing records.",
  "segments.heg.alert": "User FLOWIO is not mapped on HeG user",
  "segments.heg.user": "HeG user:",
  "segments.map": "Map user",
  "segments.load_csv": "Load CSV file",
  "segments.permissions.insufficient": "Insufficient permissions",
  "segments.functions.title": "<strong>Functions</strong>",
  "segments.functions.selected_items": "Number of chosen items: {count}",
  "segments.functions.table_header": "Functions: ",
  "segments.functions.start": "Start",
  "segments.table.search_info":
    "Showing several 100,000 entries from {rowCount} Use search to narrow your search.",
  "segments.table.row_numbers": "Entries on page: ",
  "segments.table_search.title": "Search in columns",
  "segments.table_search.from": "<strong>From: </strong>",
  "segments.table_search.to": "<strong>To: </strong>",
  "segments.table.actions": "Actions",
  "segments.table.actions.more": "More actions",
  "segments.functions.select_all": "Select all",
  "segments.choose_conditions": "Choose conditions",

  "login.app_account": "Application account",
  "login.placeholder.login": "Login name",
  "login.user_not_exist": "User {text} not exist",
  "login.please_change_password":
    "Your password was reset. Visit your email inbox for a reset link",
  "login.wrong_password": "Wrong password",
  "login.deactivated_account":
    "Your login was deactivated. Contact administrator!",
  "login.login": "Log in",
  "login.logout": "Log out",
  "login.flowio_message":
    "The only business application your employees really need!",
  "login.google.invalid_settings":
    "Incorrect settings, please contact administrator",
  "login.reset_password": "Reset password",
  "login.change_password": "Change password",
  "login.bugs_overview": "Show bugs overview",
  "login.language": "Language",
  "login.mapped_data_sources": "Mapped data sources",
  "login.personal_settings": "Personal settings",
  "login.change_password.info_message":
    "After successfull change of password you will be logged out of app to log in with new password",
  "login.active_directory.error": "Error during login with active directory",

  "reset_password.change": "change password",

  "x2y.table_data.unselected": "Unselected",
  "x2y.table_data.selected": "Selected",
  "x2y.no_items_found": "Found no items to chose from",

  "icon_selector.click_here_to_select": "Click here to select an icon",

  "favourite_templates.empty_list": "You have no favourite templates.",
  "notifications.initial_load": "Your notifications are loading",
  "notifications.template.empty": "You have no template notifications",
  "notifications.system.title": "System notification",
  "notifications.system":
    "We cannot show your notifications for templates: [{templateNames}], because you are not mapped to datasource {datasourceName}. Click here to initiate mapping.",
  "notifications.system.notification":
    "System notification: Notifiation template",
  "notifications.system.default_mapping":
    "System notification: Default mapping",

  "modal.confirmation_modal.delete_message.title": "Delete confirmation",
  "modals.confirmation_modal.delete_message":
    "Do you really want to delete this item? You can't undo this action.",
  "modals.confirmation_modal.reset_pass_message":
    "Are you sure you want to reset your password? You can't undo this action.",
  "modals.confirmation_modal.reset_pass_multiple_message":
    "Are you sure you want to reset password for all selected users? You can't undo this action.",
  "modals.confirmation_modal.deactivate_message":
    "Are you sure you want to deactivate this user?",
  "modals.confirmation_modal.deactivate_accounts_message":
    "Are you sure you want to deactivate these users?",

  "sortable.item": "Item",

  "hwr.annual_evaluation": "Annual evaluation",
  "hwr.adaptation_plan": "Adaptation plan",
  "hwr.personal_dev_plan": "Personal development plan",
  "hwr.echos_evaluation": "Evaluation of potentials",
  "hwr.back": "Back",
  "hwr.forward": "Continue evaluation",
  "hwr.show": "Show",
  "hwr.enter": "Enter",

  "hwr.rocni_hodnoceni.old": "Old evaluations",
  "hwr.rocni_hodnoceni.current": "Current evaluations",
  "hwr.rocni_hodnoceni.future": "Future evaluations",
  "hwr.rocni_hodnoceni.msg0001": "Annual performance appraisal",
  "hwr.rocni_hodnoceni.msg0002": "Employee data",
  "hwr.rocni_hodnoceni.msg0003": "Pre-filled fields are correct",
  "hwr.rocni_hodnoceni.msg0004": "First name",
  "hwr.rocni_hodnoceni.msg0005": "Date of birth",
  "hwr.rocni_hodnoceni.msg0006": "Surname",
  "hwr.rocni_hodnoceni.msg0007": "Start-date in the group",
  "hwr.rocni_hodnoceni.msg0008": "Personal number (EC)",
  "hwr.rocni_hodnoceni.msg0009": "Start-date in the position",
  "hwr.rocni_hodnoceni.msg0010": "Employee position title",
  "hwr.rocni_hodnoceni.msg0011": "Retirement date",
  "hwr.rocni_hodnoceni.msg0012": "GGS Grade",
  "hwr.rocni_hodnoceni.msg0013": "Veolia classification",
  "hwr.rocni_hodnoceni.msg0014": "Activity",
  "hwr.rocni_hodnoceni.msg0015": "O/P/R Evaluation",
  "hwr.rocni_hodnoceni.msg0016": "Jobline",
  "hwr.rocni_hodnoceni.msg0017": "Level of management",
  "hwr.rocni_hodnoceni.msg0018": "Zone",
  "hwr.rocni_hodnoceni.msg0019": "Appraisal year",
  "hwr.rocni_hodnoceni.msg0020": "Business Line",
  "hwr.rocni_hodnoceni.msg0021": "Country",
  "hwr.rocni_hodnoceni.msg0022": "Meeting date",
  "hwr.rocni_hodnoceni.msg0023": "Company / Region",
  "hwr.rocni_hodnoceni.msg0024": "Renumeration type",
  "hwr.rocni_hodnoceni.msg0026": "Position title",
  "hwr.rocni_hodnoceni.msg0027":
    "Main goals and position characteristics (Work conditions ...)",
  "hwr.rocni_hodnoceni.msg0028": "Supervisor",
  "hwr.rocni_hodnoceni.msg0029": "Work environment characteristics (optional)",
  "hwr.rocni_hodnoceni.msg0030": "Employee's comments",
  "hwr.rocni_hodnoceni.msg0031": "Supervisor's comments",
  "hwr.rocni_hodnoceni.msg0032": "Back",
  "hwr.rocni_hodnoceni.msg0033": "Save and continue",
  "hwr.rocni_hodnoceni.msg0034": "Save without checking",
  "hwr.rocni_hodnoceni.msg0035":
    "Definition of objectives and expected results",
  "hwr.rocni_hodnoceni.msg0036": "Objective",
  "hwr.rocni_hodnoceni.msg0037": "Definition",
  "hwr.rocni_hodnoceni.msg0038": "Performance indicator",
  "hwr.rocni_hodnoceni.msg0039": "Deadline",
  "hwr.rocni_hodnoceni.msg0040": "Weight",
  "hwr.rocni_hodnoceni.msg0041": "Fullfillment (%)",
  "hwr.rocni_hodnoceni.msg0042": "Evaluation of objective",
  "hwr.rocni_hodnoceni.msg0043": "Comment",
  "hwr.rocni_hodnoceni.msg0044":
    "Definition of objectives and expected results",
  "hwr.rocni_hodnoceni.msg0045":
    "Choose from 2 to 5 personal objectives and set their categories.",
  "hwr.rocni_hodnoceni.msg0046": "Choose from previous obj.",
  "hwr.rocni_hodnoceni.msg0047": "Definition",
  "hwr.rocni_hodnoceni.msg0048": "Performance indicator",
  "hwr.rocni_hodnoceni.msg0049": "Deadline",
  "hwr.rocni_hodnoceni.msg0050": "Weight %",
  "hwr.rocni_hodnoceni.msg0051": "Comment",
  "hwr.rocni_hodnoceni.msg0052": "Evaluation",
  "hwr.rocni_hodnoceni.msg0053": "Comment",
  "hwr.rocni_hodnoceni.msg0054": "Responsibility",
  "hwr.rocni_hodnoceni.msg0055": "Solidarity",
  "hwr.rocni_hodnoceni.msg0056": "Respect",
  "hwr.rocni_hodnoceni.msg0057": "Innovation",
  "hwr.rocni_hodnoceni.msg0058": "Customer orientation",
  "hwr.rocni_hodnoceni.msg0059":
    "Jak v nadcházejícím roce aktivně přispějete k bezpečnosti a ochraně zdraví při práci?",
  "hwr.rocni_hodnoceni.msg0060": "Angažovanost v oblasti BOZP",
  "hwr.rocni_hodnoceni.msg0061": "Choose strong skills of employee",
  "hwr.rocni_hodnoceni.msg0062": "Skill",
  "hwr.rocni_hodnoceni.msg0063": "Skills family",
  "hwr.rocni_hodnoceni.msg0064": "Description",
  "hwr.rocni_hodnoceni.msg0065": "Comment",
  "hwr.rocni_hodnoceni.msg0066": "Choose skills to improve",
  "hwr.rocni_hodnoceni.msg0067": "Language skills",
  "hwr.rocni_hodnoceni.msg0068": "English - level of knowledge",
  "hwr.rocni_hodnoceni.msg0069": "French - level of knowledge",
  "hwr.rocni_hodnoceni.msg0070": "Other language selection",
  "hwr.rocni_hodnoceni.msg0071": "Other language - level of knowledge",
  "hwr.rocni_hodnoceni.msg0072": "Employee desires geographical mobility",
  "hwr.rocni_hodnoceni.msg0073": "Specify (region, country, ...)",
  "hwr.rocni_hodnoceni.msg0074": "Only in Czech Republic",
  "hwr.rocni_hodnoceni.msg0075": "V rámci 1-2 let?",
  "hwr.rocni_hodnoceni.msg0076": "V rámci 3-5 let?",
  "hwr.rocni_hodnoceni.msg0077": "Employee comment",
  "hwr.rocni_hodnoceni.msg0078": "Employee desires a career development",
  "hwr.rocni_hodnoceni.msg0079": "More detail",
  "hwr.rocni_hodnoceni.msg0080": "Next role (if known)",
  "hwr.rocni_hodnoceni.msg0081": "Supervisor's summary comment",
  "hwr.rocni_hodnoceni.msg0082":
    "Would you like to have an interview with LZ Manager about your mobility / career?",
  "hwr.rocni_hodnoceni.msg0083":
    "Fill only with employees, which are entitled to a retirement pension in the next three years",
  "hwr.rocni_hodnoceni.msg0084":
    "Do you wish to go into retirement pension in the next three years?",
  "hwr.rocni_hodnoceni.msg0085": "Regular",
  "hwr.rocni_hodnoceni.msg0086": "Premature",
  "hwr.rocni_hodnoceni.msg0087": "Comment",
  "hwr.rocni_hodnoceni.msg0088":
    "Training and development actions in the past year ({year})",
  "hwr.rocni_hodnoceni.msg0089": "Action",
  "hwr.rocni_hodnoceni.msg0090": "Date",
  "hwr.rocni_hodnoceni.msg0091": "Skill family",
  "hwr.rocni_hodnoceni.msg0092": "Results obtained",
  "hwr.rocni_hodnoceni.msg0093": "Skills to develop ({year})",
  "hwr.rocni_hodnoceni.vzdelani.sub_info":
    "(Relates to skills in the current role, or skills required to advanced to the next position)",
  "hwr.rocni_hodnoceni.msg0094": "Choose skill",
  "hwr.rocni_hodnoceni.msg0095": "Training action",
  "hwr.rocni_hodnoceni.msg0096": "List of training actions",
  "hwr.rocni_hodnoceni.msg0097": "Date",
  "hwr.rocni_hodnoceni.msg0098": "Training action description",
  "hwr.rocni_hodnoceni.msg0099": "Expected results",

  "hwr.rocni_hodnoceni.msg0100": "Overall appraisal",
  "hwr.rocni_hodnoceni.msg0101": "Appraisal",
  "hwr.rocni_hodnoceni.msg0102": "Employee's comments",
  "hwr.rocni_hodnoceni.msg0103": "Supervisor's comments",
  "hwr.rocni_hodnoceni.msg0104": "Supervisor's sign",
  "hwr.rocni_hodnoceni.msg0105": "Date",
  "hwr.rocni_hodnoceni.msg0106": "Employee's sign",
  "hwr.rocni_hodnoceni.msg0107": "Evaluation of qualitative indicators",
  "hwr.rocni_hodnoceni.msg0108": "Objective",
  "hwr.rocni_hodnoceni.msg0109": "Definition",
  "hwr.rocni_hodnoceni.msg0110": "Weight (%)",
  "hwr.rocni_hodnoceni.msg0111": "Fulfillment (%)",
  "hwr.rocni_hodnoceni.msg0112": "Evaluation of individual objectives",
  "hwr.rocni_hodnoceni.msg0113": "Defined individual objectives",
  "hwr.rocni_hodnoceni.msg0114": "Definition",
  "hwr.rocni_hodnoceni.msg0115": "Category",
  "hwr.rocni_hodnoceni.msg0116": "Promise",
  "hwr.rocni_hodnoceni.msg0117": "Evaluation",
  "hwr.rocni_hodnoceni.msg0118": "Draft payout",
  "hwr.rocni_hodnoceni.msg0119": "Comment (optional)",
  "hwr.rocni_hodnoceni.msg0120":
    "Meeting date, Basic responsibilities is not defined.",
  "hwr.rocni_hodnoceni.msg0121": "Meeting date is empty.",
  "hwr.rocni_hodnoceni.msg0122": "Form is locked.",
  "hwr.rocni_hodnoceni.bozp.value":
    'Field "Angažovanost v oblasti BOZP" is not filled',
  "hwr.rocni_hodnoceni.msg0123": "Weight sum must be 100%.",
  "hwr.rocni_hodnoceni.msg0124":
    "If evaluation is set, fullfillment cannot be empty value.",
  "hwr.rocni_hodnoceni.msg0125":
    "Evaluation must be filled for each objective defined.",
  "hwr.rocni_hodnoceni.msg0126": "Objective {cil} is not defined.",
  "hwr.rocni_hodnoceni.msg0127":
    "If Renumeration type = 'SM', weight must be set for every objective.",
  "hwr.rocni_hodnoceni.msg0128":
    "If any of the objectives has weight defined, weight must be set for every other objective too.",
  "hwr.rocni_hodnoceni.msg0129":
    "Objective {cil}: If any field is set, Definition is mandatory field.",
  "hwr.rocni_hodnoceni.msg0130": "Evaluation is empty.",
  "hwr.rocni_hodnoceni.msg0131": "Responsibility",
  "hwr.rocni_hodnoceni.msg0132": "Solidarity",
  "hwr.rocni_hodnoceni.msg0133": "Respect",
  "hwr.rocni_hodnoceni.msg0134": "Innovation",
  "hwr.rocni_hodnoceni.msg0135": "Customer orientation",
  "hwr.rocni_hodnoceni.msg0136": "Some comments are missing.",
  "hwr.rocni_hodnoceni.msg0137":
    "Pole 'Angažovanost v oblasti BOZP' je povinné.",
  "hwr.rocni_hodnoceni.msg0138":
    "Strong skills: Skill #{kompetence} is not defined.",
  "hwr.rocni_hodnoceni.msg0139":
    "Silné stránky: Je-li vyplněna Kategorie dovednosti {idx}, musí být k ní vybrána alespoň jedna konkrétní dovednost.",
  "hwr.rocni_hodnoceni.msg0140":
    "Požadavky na zlepšení: Je-li vyplněna Kategorie dovednosti 1, musí být k ní vybrána alespoň jedna konkrétní dovednost.",
  "hwr.rocni_hodnoceni.msg0141":
    "If other language is selected, level of knowledge must be specified.",
  "hwr.rocni_hodnoceni.msg0142":
    "Career development: If Mobility is set to 'yes', Region must be specified.",
  "hwr.rocni_hodnoceni.msg0143":
    "If Training action #{row} = 'Yes', either action from list or description must be specified.",
  "hwr.rocni_hodnoceni.msg0144":
    "Dovednost {row}: Pokud Vzdělávací akce = 'Ano', je nutno vybrat alespoň jednu konkrétní dovednost.",
  "hwr.rocni_hodnoceni.msg0145": "Employee has not been signed yet.",
  "hwr.rocni_hodnoceni.msg0146": "Summary is empty.",
  "hwr.rocni_hodnoceni.msg0147": "Employee's comment is empty.",
  "hwr.rocni_hodnoceni.msg0148": "Supervisor's comment is empty.",
  "hwr.rocni_hodnoceni.msg0149":
    "Evaluation of qualitative indicators - Objective #{row}: If definition is filled, fulfillment must be specified (0 ... 100).",
  "hwr.rocni_hodnoceni.msg0150":
    "Evaluation of individual objectives - Objective #{row}: If definition is filled, fulfillment must be specified (0 ... 100)",
  "hwr.rocni_hodnoceni.msg0151": "Self appraisal",
  "hwr.rocni_hodnoceni.msg0152": "Previous",
  "hwr.rocni_hodnoceni.msg0153": "Current",
  "hwr.rocni_hodnoceni.msg0154": "Next",
  "hwr.rocni_hodnoceni.msg0155": "Evaluate subordinates",
  "hwr.rocni_hodnoceni.msg0156": "Proceed",
  "hwr.rocni_hodnoceni.msg0157": "View appraisals of all subordinates",
  "hwr.rocni_hodnoceni.msg0158": "Proceed",
  "hwr.rocni_hodnoceni.msg0159": "Personal number",
  "hwr.rocni_hodnoceni.msg0160": "Previous",
  "hwr.rocni_hodnoceni.msg0161": "Current",
  "hwr.rocni_hodnoceni.msg0162": "State of Current",
  "hwr.rocni_hodnoceni.msg0163": "Next",
  "hwr.rocni_hodnoceni.msg0164": "Save",
  "hwr.rocni_hodnoceni.msg0165": "Entered promise completed",
  "hwr.rocni_hodnoceni.msg0166": "Evaluated",
  "hwr.rocni_hodnoceni.msg0167": "Sign",
  "hwr.rocni_hodnoceni.msg0168": "Form was successfully saved.",
  "hwr.rocni_hodnoceni.msg0169": "Form was successfully signed.",
  "hwr.rocni_hodnoceni.msg0170": "Stanovení cílů na aktuální rok",
  "hwr.rocni_hodnoceni.msg0171": "Select 1 to 5 Purpose Objectives",
  "hwr.rocni_hodnoceni.msg0172":
    "Hodnocení cílů 'Smysl naší činnosti - Veolia Purpose' - uplynulý rok",
  "hwr.rocni_hodnoceni.msg0173":
    "To define a goal, Definition and Category are mandatory fields.",
  "hwr.rocni_hodnoceni.msg0174":
    "If evaluation is set, fullfillment cannot be empty value.",
  "hwr.rocni_hodnoceni.msg0175": "Komentář funkč. nadříz.",
  "hwr.rocni_hodnoceni.msg0176": "Podpis funkč. nadříz.",
  "hwr.rocni_hodnoceni.msg0177": "Current appraisal's state",
  "hwr.rocni_hodnoceni.msg0178": "",
  "hwr.rocni_hodnoceni.msg0179": "",
  "hwr.rocni_hodnoceni.msg0180": "",
  "hwr.rocni_hodnoceni.msg0181": "",
  "hwr.rocni_hodnoceni.msg0182": "",
  "hwr.rocni_hodnoceni.msg0183": "",
  "hwr.rocni_hodnoceni.msg0184": "",
  "hwr.rocni_hodnoceni.msg0185": "",
  "hwr.rocni_hodnoceni.msg0186": "",
  "hwr.rocni_hodnoceni.msg0187": "",
  "hwr.rocni_hodnoceni.msg0188": "",
  "hwr.rocni_hodnoceni.msg0189": "",
  "hwr.rocni_hodnoceni.msg0190": "",
  "hwr.rocni_hodnoceni.msg0191": "",
  "hwr.rocni_hodnoceni.msg0192": "",
  "hwr.rocni_hodnoceni.msg0193": "",
  "hwr.rocni_hodnoceni.msg0194": "",
  "hwr.rocni_hodnoceni.msg0195": "",
  "hwr.rocni_hodnoceni.msg0196": "",
  "hwr.rocni_hodnoceni.msg0197": "",
  "hwr.rocni_hodnoceni.msg0198": "",
  "hwr.rocni_hodnoceni.msg0199": "",

  "hwr.rocni_hodnoceni.description": "Popis:",

  "hwr.echos_hodnoceni.title":
    "Evaluation of potentials: {name} ({region}) {year}",
  "hwr.echos_hodnoceni.title_short": "Evaluation of potentials",
  "hwr.echos_hodnoceni.basic_data": "Basic information",
  "hwr.echos_hodnoceni.work_and_personal_data": "Work and personal data",
  "hwr.echos_hodnoceni.personal_dev": "Personal progress",
  "hwr.echos_hodnoceni.results": "Results",
  "hwr.echos_hodnoceni.results2": "Results:",
  "hwr.echos_hodnoceni.region_list": "Regions list",
  "hwr.echos_hodnoceni.eval_list": "Evaluations list",
  "hwr.echos_hodnoceni.working_place": "Working position",
  "hwr.echos_hodnoceni.org4": "Department / Division",
  "hwr.echos_hodnoceni.direct_leader": "Hierarchical supervisor",
  "hwr.echos_hodnoceni.direct_subs_cnt": "Direct subordinates",
  "hwr.echos_hodnoceni.retirement_5yr": "Retirement in 5 years",
  "hwr.echos_hodnoceni.subs_cnt": "Total subordinates",
  "hwr.echos_hodnoceni.years_cnt": "Years in group",
  "hwr.echos_hodnoceni.age": "Age",
  "hwr.echos_hodnoceni.en_level": "English knowledge",
  "hwr.echos_hodnoceni.education_level": "Education degree",
  "hwr.echos_hodnoceni.fr_level": "French knowledge",
  "hwr.echos_hodnoceni.salary": "Salary clasification",
  "hwr.echos_hodnoceni.talent": "T",
  "hwr.echos_hodnoceni.supervisor": "Supervisor",
  "hwr.echos_hodnoceni.career": "Career development",
  "hwr.echos_hodnoceni.successor": "S",
  "hwr.echos_hodnoceni.mobility": "Mobility",
  "hwr.echos_hodnoceni.mobility_cz": "Mobility only for CZ",
  "hwr.echos_hodnoceni.key_worker": "KW",
  "hwr.echos_hodnoceni.dev_spec": "Development specification",
  "hwr.echos_hodnoceni.ggs_grade": "Veolia classification",
  "hwr.echos_hodnoceni.training_1": "Training 1",
  "hwr.echos_hodnoceni.training_2": "Training 2",
  "hwr.echos_hodnoceni.description": "Description",
  "hwr.echos_hodnoceni.jobline": "Jobline and positions",
  "hwr.echos_hodnoceni.education": "Education",
  "hwr.echos_hodnoceni.planned_trainings":
    "Planned trainings based on personal development",
  "hwr.echos_hodnoceni.past_trainings": "Trainings in the past three years",
  "hwr.echos_hodnoceni.higher_function": "Function with higher responsibility",
  "hwr.echos_hodnoceni.next_position_description":
    "Next position - description",
  "hwr.echos_hodnoceni.next_training": "Next training",
  "hwr.echos_hodnoceni.next_training_description":
    "Next training - description",
  "hwr.echos_hodnoceni.specialist": "Specialist",
  "hwr.echos_hodnoceni.faculty": "Faculty",
  "hwr.echos_hodnoceni.expert_international": "Expert (internationally)",
  "hwr.echos_hodnoceni.eval_summary": "Evaluation summary",
  "hwr.echos_hodnoceni.region": "Region",
  "hwr.echos_hodnoceni.full_name": "Full Name",
  "hwr.echos_hodnoceni.personal_id": "Personal #",
  "hwr.echos_hodnoceni.current_year": "Current",
  "hwr.echos_hodnoceni.current_state": "Current Eval. State",
  "hwr.echos_hodnoceni.reference": "Reference",
  "hwr.echos_hodnoceni.function": "Function",
  "hwr.echos_hodnoceni.from": "From",
  "hwr.echos_hodnoceni.to": "To",
  "hwr.echos_hodnoceni.school": "School",
  "hwr.echos_hodnoceni.fakulty": "Faculty",
  "hwr.echos_hodnoceni.field": "Field",
  "hwr.echos_hodnoceni.degree": "Degree",
  "hwr.echos_hodnoceni.ended": "Ended",
  "hwr.echos_hodnoceni.action_name": "Action",
  "hwr.echos_hodnoceni.deadline_plan": "Deadline (plan)",
  "hwr.echos_hodnoceni.name": "Name",

  "hwr.personal_dev_plan.title": "Personal development plan",
  "hwr.personal_dev_plan.personal_plan": "Personal plan",
  "hwr.personal_dev_plan.subs_plans": "Subordinates plans",
  "hwr.personal_dev_plan.new_entry": "New entry",
  "hwr.personal_dev_plan.cancel_new_entry": "Cancel",
  "hwr.personal_dev_plan.submit_new_entry": "Save",
  "hwr.personal_dev_plan.organization": "Organization",
  "hwr.personal_dev_plan.state": "State",
  "hwr.personal_dev_plan.plan_from": "Plan from",
  "hwr.personal_dev_plan.plan_to": "Plan to",
  "hwr.personal_dev_plan.superior": "Superior",
  "hwr.personal_dev_plan.current_pos": "Current position",
  "hwr.personal_dev_plan.current_level": "Position level",
  "hwr.personal_dev_plan.planned_position": "Planned pos. (if known)",
  "hwr.personal_dev_plan.planned_position_level": "Planned position level",
  "hwr.personal_dev_plan.planned_date": "Planned date",
  "hwr.personal_dev_plan.records_of_meetings": "Records of meetings",
  "hwr.personal_dev_plan.meeting_1": "Meeting 1",
  "hwr.personal_dev_plan.meeting_2": "Meeting 2",
  "hwr.personal_dev_plan.meeting_3": "Meeting 3",
  "hwr.personal_dev_plan.meeting_4": "Meeting 4",
  "hwr.personal_dev_plan.note": "Note",
  "hwr.personal_dev_plan.full_name": "Full Name",
  "hwr.personal_dev_plan.personal_id": "Personal #",
  "hwr.personal_dev_plan.plan_period": "Planned period",
  "hwr.personal_dev_plan.goals": "Development Goals",
  "hwr.personal_dev_plan.actions": "Goals Actions",
  "hwr.personal_dev_plan.benefit": "Expected Benefit",
  "hwr.personal_dev_plan.criteria": "Criteria",
  "hwr.personal_dev_plan.deadline_plan": "Deadline (plan)",
  "hwr.personal_dev_plan.performance_evaluation": "Performance Evaluation",
  "hwr.personal_dev_plan.deadline_real": "Deadline (real)",

  "hwr.adaptation_plan.title": "Adaptation plan: {name} ({region}) {year}",
  "hwr.adaptation_plan.personal_plan": "Personal plan",
  "hwr.adaptation_plan.subs_plans": "Subordinates plans",
  "hwr.adaptation_plan.type": "Type",
  "hwr.adaptation_plan.state": "State",
  "hwr.adaptation_plan.position": "Position",
  "hwr.adaptation_plan.position_from": "From position",
  "hwr.adaptation_plan.position_to": "To position",
  "hwr.adaptation_plan.date_from": "Adaptation from",
  "hwr.adaptation_plan.date_to": "Adaptation to",
  "hwr.adaptation_plan.new_position_from": "New position from",
  "hwr.adaptation_plan.processed_by": "Processed by",
  "hwr.adaptation_plan.approved_by": "Approved by",
  "hwr.adaptation_plan.full_name": "Full Name",
  "hwr.adaptation_plan.personal_id": "Personal #",
  "hwr.adaptation_plan.view": "View plan",

  "settings.user2notif.assign_notif_to_user":
    "Chose templates to get notifications from",

  "webview.change_server": "Change server",
  "webview.clear_storage": "Clear storage",

  "whereItem.relationType.textValue": "Text",
  "whereItem.relationType.numberValue": "Number",
  "whereItem.relationType.booleanValue": "Boolean",
  "whereItem.relationType.dateValue": "Date",
  "whereItem.relationType.dateValueRange": "Date range",
  "whereItem.relationType.dateValueDynamic": "Dynamic date",
  "whereItem.relationType.like": "Like",
  "whereItem.relationType.isnull": "Null",
  "whereItem.relationType.notnull": "Not Null",
  "whereItem.relationType.dynamicValue": "Relation to another column",
  "whereItem.relationType.selectValue": "Set of values",
  "whereItem.relationType.ewaLogin": "Login FLOWIO",
  "whereItem.relationType.ewaUsername": "Username FLOWIO",
  "whereItem.relationType.flowioLogin": "Login FLOWIO",
  "whereItem.relationType.flowioUsername": "Username FLOWIO",
  "whereItem.relationType.hegLogin": "Login HeG",
  "whereItem.relationType.hegUsername": "Username HeG",
  "whereItem.whereItemList": "Where item list",

  "WhereItemFilter.update_old": "(updates an existing filter)",
  "WhereItemFilter.save_new": "(creates a new filter)",

  "WhereItemFilter.enter_filter_name": "save filter as:",

  "WhereItemForm.selected": "Selected filter",
  "WhereItemForm.new_filter": "New filter",
  "WhereItemForm.boolean_options.true": "yes",
  "WhereItemForm.boolean_options.false": "no",

  "whereItem.type.text": "Text",
  "whereItem.type.boolean": "Checkbox",
  "whereItem.type.date": "Date",
  "whereItem.type.dateRange": "Date range",
  "whereItem.type.dynamicDate": "Dynamic range",
  "whereItem.type.number": "Number",
  "whereItem.type.dynamic": "Select from template",
  "whereItem.type.like": "Similar as",
  "whereItem.type.null": "NULL",
  "whereItem.type.notnull": "NOT NULL",
  "whereItem.type.relation": "Relation",
  "whereItem.type.whereItemList": "Condition list",
  "whereItem.type.flowioLogin": "My FLOWIO login",
  "whereItem.type.flowioUsername": "My FLOWIO username",
  "whereItem.type.hegLogin": "My Helios login",
  "whereItem.type.hegUsername": "My Helios username",
  "whereItem.caseSensitive": "Case sensitive",

  "searchType.text": "Text",
  "searchType.boolean": "Checkbox",
  "searchType.date": "Date",
  "searchType.daterange": "Date range",
  "searchType.dynamicDate": "Dynamic date",
  "searchType.number": "Number",

  "FilterPicker.save_as_default": "Set filter as default",
  "FilterPicker.invalid_name": "You cannot use this filter name",
  "FilterPicker.new_filter": "New filter",

  "FilterPicker.static.empty": "EMPTY FILTER",

  "actionsFilter.title": "Actions filter",
  "actionsFilter.delete": "Delete",
  "actionsFilter.create": "Create",
  "actionsFilter.createInRow": "Create in row",
  "actionsFilter.edit": "Edit",
  "actionsFilter.copy": "Copy",
  "actionsFilter.copyInRow": "Copy in row",
  "actionsFilter.editInRow": "Edit in row",
  "actionsFilter.export": "Export",
  "actionsFilter.visibility": "Visibility",
  "actionsFilter.prefill": "Prefill",

  advanced_search: "Advanced search",
  "advanced_search.run": "Run query",
  "advanced_search.switch_to_advanced_mode": "Switch to advanced mode",
  "advanced_search.switch_to_simple_mode": "Switch to simple mode",
  "advanced_search.cannot_render_as_simple":
    "Selected filter contains advanced logic, which cannot be displayed in simple mode",
  "advanced_search.switch_to_advanced_to_view":
    "Switch to advanced mode to edit selected filter",

  "dynamicDate.unit.second": "seconds",
  "dynamicDate.unit.minute": "minutes",
  "dynamicDate.unit.hour": "hours",
  "dynamicDate.unit.day": "days",
  "dynamicDate.unit.week": "weeks",
  "dynamicDate.unit.month": "months",
  "dynamicDate.unit.year": "years",

  "dynamicDate.context.now": "From now",
  "dynamicDate.context.today": "From today",
  "dynamicDate.context.unitStart": "Unit start",
  "dynamicDate.context.unitEnd": "Unit end",

  "impersonation.impersonated_by": "impersonated by",
  "impersonation.impersonate": "impe rsonate",
  "impersonation.cancel_impersonation": "cancel impersonation",
  "impersonation.run_impersonation_function":
    "You are impersonating user _NAME_. Do you really want to run the function ",

  "calendar.events.title": "Events",
  "calendar.events.all_day_event": "Allday event",
  "calendar.mobile_popup.delete": "Delete",
  "calendar.mobile_popup.edit": "Edit",
  "calendar.mobile_popup.share": "Share",
  "calendar.event_list.start": "Start",
  "calendar.event_list.end": "End",
  "calendar.event_list.category": "Category",

  "input.text.maxLength":
    "You have reached the maximum nuber of characters in a word",
  "input.text.invalidDecimal":
    "Invalid decimal number. Maximal allowed decimal is {max_decimal}",

  "input.date_range.invalid": "Invalid value. You must fill in all segments.",
  "input.date.placeholder": "YYYY-MM-DD",
  "input.date_time.placeholder": "YYYY-MM-DD hh:mm AM/PM",

  "gate.options.and": "AND",
  "gate.options.or": "OR",
  "heg.only.options.login": "HeG Login",
  "heg.only.options.username": "HeG Username",
  "general.flowio_login": "FLOWIO Login",
  "general.flowio_username": "FLOWIO Username",

  "ssrs.parameters": "Report parameters",
  "ssrs.show_for_parameters": "Show for selected parameters",
  "ssrs.parameter.visibility": "Visibility",
  "ssrs.parameter.editability": "Editability",
  "ssrs.parameter.date_format": "Format as",
  "ssrs.parameter.type": "Type",
  "ssrs.parameter.value": "Value",

  "ssrs.parameter.type.static": "Static",
  "ssrs.parameter.type.dynamic": "Dynamic",
  "ssrs.parameter.type.select": "Select",

  "ssrs.parameter.dynamic.my_id": "My Helios ID",
  "ssrs.parameter.dynamic.this_day": "This day",
  "ssrs.parameter.dynamic.this_month": "This month",
  "ssrs.parameter.dynamic.this_year": "This year",
  "ssrs.parameter.dynamic.current_date": "Current date",

  "ssrs.parameter.date_format.date": "Datum",
  "ssrs.parameter.date_format.datetime": "Datum a čas",

  "ssrs.parameter.datasource.error":
    "There was error during data sources fetch",

  "ssrs.parameters.empty":
    "No available parameters.\nCheck the report path and valid data source.",

  "ssrs.parameter.datasource_mapping.error":
    "There was error during unmapped data sources fetch",

  ...pageTitleMessages,
  ...feedbackModalsMessages,
  ...toastMessages,
  ...hegMappingMessages,
  ...tableHeaderMessages,
  ...tBuilderValidationMessages,
} as const;

export default intlMessagesEn;
